module.exports = "td {\r\n    text-align: center;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/leaderboard/leaderboard.component.css
// module id = ./src/app/leaderboard/leaderboard.component.css
// module chunks = main